import { render, staticRenderFns } from "./ShiftEditorEmployeeSelectorDialog.vue?vue&type=template&id=b6c975bc&scoped=true&lang=pug&"
import script from "./ShiftEditorEmployeeSelectorDialog.vue?vue&type=script&lang=ts&"
export * from "./ShiftEditorEmployeeSelectorDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ShiftEditorEmployeeSelectorDialog.vue?vue&type=style&index=0&id=b6c975bc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6c975bc",
  null
  
)

export default component.exports